import { apiCall } from './realApi';
import type { WorkloadSummary, WorkloadCreate, WorkloadUpdate } from '../types/workload';

export const workloadsApi = {
  async getAll(clientId?: string): Promise<WorkloadSummary[]> {
    const params = clientId ? `?client_id=${clientId}` : '';
    return apiCall(`/workloads${params}`);
  },

  async getById(id: string): Promise<WorkloadSummary> {
    return apiCall(`/workloads/${id}`);
  },

  async create(data: WorkloadCreate, clientId?: string): Promise<WorkloadSummary> {
    const params = clientId ? `?client_id=${clientId}` : '';
    return apiCall(`/workloads${params}`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async update(id: string, data: WorkloadUpdate): Promise<WorkloadSummary> {
    return apiCall(`/workloads/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  async delete(id: string): Promise<void> {
    return apiCall(`/workloads/${id}`, { method: 'DELETE' });
  },

  async linkProject(workloadId: string, projectId: string): Promise<void> {
    return apiCall(`/workloads/${workloadId}/projects/${projectId}`, {
      method: 'POST',
    });
  },

  async unlinkProject(workloadId: string, projectId: string): Promise<void> {
    return apiCall(`/workloads/${workloadId}/projects/${projectId}`, {
      method: 'DELETE',
    });
  },

  async getForProject(projectId: string): Promise<WorkloadSummary[]> {
    return apiCall(`/projects/${projectId}/workloads`);
  },

  async getTagKeys(prefix: string = '', clientId?: string): Promise<string[]> {
    const params = new URLSearchParams();
    if (prefix) params.set('prefix', prefix);
    if (clientId) params.set('client_id', clientId);
    const qs = params.toString();
    return apiCall(`/workloads/tags/keys${qs ? `?${qs}` : ''}`);
  },

  async getTagValues(key: string, prefix: string = '', clientId?: string): Promise<string[]> {
    const params = new URLSearchParams();
    params.set('key', key);
    if (prefix) params.set('prefix', prefix);
    if (clientId) params.set('client_id', clientId);
    return apiCall(`/workloads/tags/values?${params.toString()}`);
  },
};
